var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('div',{staticClass:"d-flex vertical-center justify-content-center align-items-center",staticStyle:{"height":"840px","dislay":"flex"}},[_c('LoadingMDL')],1)]:[_c('Finish',{attrs:{"ifImage":false,"imgUrl":_vm.imgUrl,"message":_vm.score,"showbtn":true},on:{"nextRoute":function($event){return _vm.nextRouteFunction()}}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }